import { render, staticRenderFns } from "./advanced-analytics.vue?vue&type=template&id=22b125ab&scoped=true&"
import script from "./advanced-analytics.vue?vue&type=script&lang=js&"
export * from "./advanced-analytics.vue?vue&type=script&lang=js&"
import style0 from "./advanced-analytics.vue?vue&type=style&index=0&id=22b125ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b125ab",
  null
  
)

export default component.exports